<div class="flowchart-image-container">
  <img src="assets/images/precinct/mrpflowchart.png" alt="Zoomed Image">
</div>

<button mat-icon-button class="flowchart-close-button" mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
